import SchemaOrg from '../../components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import BrandsSection from './components/BrandsSection';
import QualificationsSection from './components/QualificationsSection';
import RealisationsSection from './components/RealisationsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CommitmentsSection from './components/CommitmentsSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

const HomePage = () => (
  <>
    <SchemaOrg />
    <main className="font-[Poppins] antialiased">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <BrandsSection />
      <QualificationsSection />
      <RealisationsSection />
      <TestimonialsSection />
      <CommitmentsSection />
      <ContactSection />
      <FooterSection />
    </main>
  </>
);

export default HomePage;
